import React from 'react';
import { useSelector } from 'react-redux';

import { eventListSelector } from '../../features/events/eventsSlice';
import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';

import EventListCard from './EventListCard.jsx';
import Marquee from "react-fast-marquee";
import { Grid } from '@mui/material';




const EventTicker = () => {

    const dimentions = useSelector(liveTrackinglayoutSelector);
    const eventTicker = useSelector(state => state.events.eventTicker);
    const eventList = useSelector(eventListSelector);

    const tickbuild = () => {
        let ticker = [];
        eventList.forEach((eventId, index) => {
            if (index > 0 && index < 30) {
                ticker.push(
                    <div style={{ marginTop: '8px', marginBottom: '3px' }} key={eventId}>
                        <EventListCard
                            eventId={eventId}
                            key={eventId}
                            index={index}
                        />
                    </div>
                );
            }
        })
        return (

            <Grid
                container
                direction="row"
                alignContent="stretch"
                alignItems="stretch"
            >
                {
                    ticker
                }
            </Grid>

        );
    }


    return (
        <div style={dimentions.footer}>
            {
                eventTicker &&

                <div style={{
                    ...dimentions.footer,
                    left: dimentions.content.left
                }}>
                    <Marquee
                        pauseOnClick={true}
                        pauseOnHover={true}
                        speed={100}
                        loop={0}
                        gradient={false}
                        gradientWidth={100}
                        delay={3}
                    >
                        {tickbuild()}
                    </Marquee>
                </div>
            }

        </div>

    )
}

export default React.memo(EventTicker);
/*

<Marquee
            pauseOnClick={true}
            pauseOnHover={true}
            speed={175}
            loop={0}
            gradient={false}
            gradientWidth={100}
            delay={10}
            style={dimentions.footer}
        >
            {tickbuild()}
        </Marquee>


<div>

            <div>
                <Marquee
                    pauseOnClick={true}
                    pauseOnHover={true}
                    speed={175}
                    loop={0}
                    gradient={false}
                    gradientWidth={100}
                    delay={30}
                >
                    {tickbuild()}
                </Marquee>
            </div>
            <div>
                {lastEvent()}
            </div>
        </div>
*/
/*
return (
        <Ticker
            style={{
                width: '100%'
            }}
            speed={5}
            move={move}
        >
            {({ index }) => {
                //console.log("Ticker component", index);
                return tickbuild();
            }}
        </Ticker>
    );
*/

/*const tickevent = (i) => {
        if (assetNames) {
            const eventId = eventList[i];
            const eventData = eventContent[`${eventId}`];
            if (eventData) {
                if (assetNames[`${eventData.assetID}`]) {
                    const regn = assetNames[`${eventContent[`${eventId}`].assetID}`].regn
                    return (
                        <EventListCard
                            eventData={eventData}
                            regn={regn}
                            key={eventId}
                            index={i}
                        />
                    );
                }
            }

        }

    }*/

/*return (
    <Ticker
        style={{
            width: '100%'
        }}
        speed={10}
        move={move}
    >
        {({ index }) => {
            //console.log("Ticker component", index);
            return tickevent(index);
        }}
    </Ticker>
);*/